module.exports = __webpack_public_path__ + "images/emoji/fish_cake.e379d45d696bd77266e0.png";